import { Table, Modal, Pagination, HeadItemType } from 'components'
import { useState, useEffect, Dispatch, SetStateAction } from 'react'
import { useParams } from 'react-router-dom'

import * as S from './styles'
import { Skeleton } from '@mui/material'
import { toast } from 'react-toastify'
import { getPendingEDIs } from 'services/salesOrder'
import { PendingEDI } from 'store/SalesOrderContext/types/PendingEDI'
import { formatDate } from 'commons/utils/date'

export interface PropsModal {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const ModalPendingEDI = ({ open, setOpen }: PropsModal) => {
  const { orderNumber } = useParams()
  const [loading, setLoading] = useState(true)
  const [pendingIssues, setPendingIssues] = useState<PendingEDI[]>([])

  const [currentPage, setCurrentPage] = useState<number>(1)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [totalItems, setTotalItems] = useState<number>(0)
  const PAGE_SIZE = 10

  const headValues: HeadItemType[] = [
    { label: 'Data', columnName: 'Data' },
    { label: 'Hora', columnName: 'Hora' },
    { label: 'Material', columnName: 'Material' },
    { label: 'Matriz', columnName: 'Matriz' },
    { label: 'Centro', columnName: 'Centro' },
    { label: 'Quantidade', columnName: 'Quantidade' },
    { label: 'Mensagem', columnName: 'Mensagem' }
  ]

  const renderBody = () => {
    if (loading) return renderSkeleton()
    if (!pendingIssues.length) return []

    return pendingIssues.map((pendingIssue, index) => {
      return {
        id: `tracking-item-${index}`,
        content: [
          formatDate(pendingIssue?.dt_cadt) ?? '--',
          formatDate(pendingIssue?.dt_cadt, 'HH[h]mm') ?? '--',
          pendingIssue?.cd_matr ?? '--',
          pendingIssue?.cd_mtrz_matr ?? '--',
          pendingIssue?.cd_cent_matr ?? '--',
          pendingIssue?.qt_item ?? '--',
          pendingIssue?.ds_msgm ?? '--'
        ]
      }
    })
  }

  const renderSkeleton = () => {
    const skeleton = []
    for (let i = 0; i < 3; i++) {
      skeleton.push({
        id: `pendingIssue-loading-${i}`,
        content: [
          <Skeleton key="pendingIssue-skeleton-1" width={120} height={30} />,
          <Skeleton key="pendingIssue-skeleton-2" width={60} height={30} />,
          <Skeleton key="pendingIssue-skeleton-2" width={100} height={30} />,
          <Skeleton key="pendingIssue-skeleton-2" width={100} height={30} />,
          <Skeleton key="pendingIssue-skeleton-2" width={100} height={30} />,
          <Skeleton key="pendingIssue-skeleton-2" width={30} height={30} />,
          <Skeleton key="pendingIssue-skeleton-2" width={200} height={30} />
        ]
      })
    }
    return skeleton
  }

  const handleClose = () => {
    setCurrentPage(1)
    setOpen(false)
  }

  const getPendingIssue = async () => {
    setLoading(true)

    try {
      const response = await getPendingEDIs(
        { paginas: currentPage, linhas: PAGE_SIZE },
        `${orderNumber}`
      )

      if (response && response.length) {
        const { linhas } = response[0]

        setPendingIssues(response)
        setTotalItems(linhas)
        setTotalPages(Math.ceil(linhas / PAGE_SIZE))
      }
    } catch (error) {
      toast.error('Erro ao carregar as pendências do pedido')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!loading || open) {
      getPendingIssue()
    }
  }, [currentPage, open])

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title={`Pendência Pedido: #${orderNumber}`}
      closeAction={handleClose}
      showAction={false}
    >
      <S.Content>
        <S.DescriptionWrapper>
          Acompanhe aqui todas as pendências disponíveis.
        </S.DescriptionWrapper>

        <S.TableWrapper>
          <Table
            headData={headValues}
            bodyData={renderBody()}
            notScrollable
            rowHeight={40}
          />
        </S.TableWrapper>

        {pendingIssues && pendingIssues.length > 0 && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            numberOfPages={totalPages}
            numberOfItems={totalItems}
            itemsPerPage={PAGE_SIZE}
            disabled={loading}
          />
        )}
      </S.Content>
    </Modal>
  )
}

export default ModalPendingEDI
